import type { GlobalState } from '../../global/types';

type PendingPhoneLoginAction = 'idle' | 'returnToPhoneNumber' | 'providePhone';

export function getPendingPhoneLoginAction(
  hasPendingPhoneLogin: boolean,
  authState: GlobalState['auth']['state'],
  isConnectionReady: boolean,
): PendingPhoneLoginAction {
  void isConnectionReady;

  if (!hasPendingPhoneLogin) {
    return 'idle';
  }

  if (authState == null || authState === 'authorizationStateWaitQrCode') {
    return 'returnToPhoneNumber';
  }

  if (authState === 'authorizationStateWaitPhoneNumber') {
    return 'providePhone';
  }

  return 'idle';
}
